import { MapsAPILoader } from '@agm/core';
import {
  Component,
  ElementRef,
  Input,
  NgZone,
  OnInit,
  ViewChild,
} from '@angular/core';
import { filter } from 'rxjs/operators';
import {
  IFilterStation,
  InputStatus,
  IPoint,
  IStation,
} from '../core/interfaces';
import { DataService } from '../core/services/data.service';
import { ExcelService } from '../core/services/excel.service';
import { MathService } from '../core/services/math.service';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
})
export class MapComponent implements OnInit {
  @Input()
  public hostImages = '';
  @Input()
  public apiUrl = '';
  public filters: Array<IFilterStation> = [];
  public title: string = 'AGM project';
  public latitudeStart: number;
  public longitudeStart: number;
  public latitudeEnd: number;
  public longitudeEnd: number;
  public origin: IPoint;
  public currentClient: IPoint;
  public routeOrigin: IPoint;
  public routeDestination: IPoint;
  public travelMode;

  public zoom: number;
  public address: string;
  private geoCoder;
  public stations: Array<IStation> = [];
  public stationsBase: Array<IStation> = [];
  public pointStart = '/assets/imgs/point_start.png';
  public iconFilter = '/assets/filter.svg';
  public pointEnd = '/assets/imgs/point_end.png';
  public iconStation = '/assets/imgs/point_station.png';
  private ZOOM_MAP_PERU = 5;
  private ZOOM_MY_POSITION = 15;
  private readonly LATITUD_INITIAL = -10.3451329;
  private readonly LONGITUD_INITIAL = -74.694612;
  public zoomRoute = 13;
  public colorRoute = '#FF3838';
  public renderOptions = {
    suppressMarkers: true,
    polylineOptions: { strokeColor: '#FF3838' },
  };
  @ViewChild('searchStart')
  public searchStartElementRef: ElementRef;
  @ViewChild('searchEnd')
  public searchEndElementRef: ElementRef;
  public pointsBetween = [];
  public showFilters = false;
  public searchStartModel = '';
  public searchEndModel = '';
  public searchStartStatus: InputStatus = { complete: false, focus: false };
  public searchEndStatus: InputStatus = { complete: false, focus: false };
  private previous;
  private posStation = null;
  public userLocationMarkerAnimation = 'BOUNCE';
  public map: any;
  constructor(
    private _dataService: DataService,
    private _excelService: ExcelService,
    private _mathService: MathService,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone
  ) {}

  ngOnInit(): void {
    this._dataService.setApi(this.apiUrl);
    this._chargeFilters();
    this.mapsAPILoader.load().then(() => {
      this.travelMode = google.maps.TravelMode.DRIVING;
      this._positionInitial();
      //this._setCurrentLocation();
      this.geoCoder = new google.maps.Geocoder();
      this.activeSearchStart();
      this.activeSearchEnd();
    });

    this._seturl();
  }
  private _chargeStations(): void {
    this._dataService.chageStations().subscribe((stations) => {
      this.stations = stations;
      this.stationsBase = [...this.stations];
    });
  }
  public focus(inputStatus: InputStatus): void {
    inputStatus.focus = true;
  }
  public blur(inputStatus: any): void {
    inputStatus.focus = false;
  }
  private _seturl(): void {
    this.pointStart = this.hostImages + this.pointStart;
    this.iconFilter = this.hostImages + this.iconFilter;
    this.pointEnd = this.hostImages + this.pointEnd;
  }
  public showFilterMobile(): void {
    this.showFilters = !this.showFilters;
  }
  public responseRoute(evt: any): void {
    const { routes } = evt;
    if (routes && routes.length > 0) {
      const { overview_path } = routes[0];
      this.pointsBetween = overview_path;

      this._filterStations();
    } else {
      this.pointsBetween = [];
    }
  }
  public activeSearchStart(): void {
    let autocomplete = new google.maps.places.Autocomplete(
      this.searchStartElementRef.nativeElement
    );
    autocomplete.addListener('place_changed', () => {
      this.ngZone.run(() => {
        let place: google.maps.places.PlaceResult = autocomplete.getPlace();
        if (place.geometry === undefined || place.geometry === null) {
          this._removeSearchStart();
          return;
        }
        this.latitudeStart = place.geometry.location.lat();
        this.longitudeStart = place.geometry.location.lng();
        this.zoom = this.zoomRoute;
        this.routeOrigin = {
          lat: this.latitudeStart,
          lng: this.longitudeStart,
        };
        this.searchStartStatus.complete = true;
        this._showIconInitial(this.routeOrigin);
      });
    });
  }
  protected mapReady(map): void {
    this.map = map;
    this._chargePositionClient();
  }

  public activeSearchEnd(): void {
    let autocomplete = new google.maps.places.Autocomplete(
      this.searchEndElementRef.nativeElement
    );
    autocomplete.addListener('place_changed', () => {
      this.ngZone.run(() => {
        let place: google.maps.places.PlaceResult = autocomplete.getPlace();
        if (place.geometry === undefined || place.geometry === null) {
          this._removeSearchEnd();
          return;
        }
        this.latitudeEnd = place.geometry.location.lat();
        this.longitudeEnd = place.geometry.location.lng();
        this.zoom = this.zoomRoute;
        this.routeDestination = {
          lat: this.latitudeEnd,
          lng: this.longitudeEnd,
        };
        this.origin = {
          ...this.routeDestination,
        };

        this.searchEndStatus.complete = true;
      });
    });
  }
  private _removeSearchEnd(): void {
    this.searchEndStatus.complete = false;
    this.routeDestination = null;
    this.latitudeEnd = this.longitudeEnd = null;
    this._removeRoute();
  }
  private _removeSearchStart(): void {
    this.routeOrigin = null;
    this.searchStartStatus.complete = false;
    this.latitudeStart = this.longitudeStart = null;
  }
  private _removeRoute(): void {
    this.routeDestination = null;
    this.longitudeEnd = null;
    this.latitudeEnd = null;
  }
  public exportStations(): void {
    const filters = this.filters.map((filter) => {
      return filter.name;
    });
    const headers = ['#', 'Nombre del Grifo', 'Dirección', ...filters];

    const statisns = this.stations.map((station: IStation, index) => {
      const { name, direction, attributes } = station;
      const filtersStations = this.filters.map((fil) => {
        const { id, name } = fil;
        const hasattribute = attributes.some((idAtribute) => {
          return Number(idAtribute) === Number(id);
        });
        return hasattribute ? name : '-';
      });
      return [index + 1, name, direction, ...filtersStations];
    });
    const dataExport = [headers, ...statisns];
    this._excelService.exportAsExcelFile(dataExport, 'Estaciones');
  }
  public myPosition(): void {
    this.searchStartElementRef.nativeElement.value = '';
    this.searchStartStatus.complete = false;
    this.routeOrigin = {
      ...this.currentClient,
    };
    if (!this.latitudeEnd) {
      this._showIconInitial(this.currentClient);
    }

    this.latitudeStart = this.currentClient.lat;
    this.longitudeStart = this.currentClient.lng;
  }
  private _showIconInitial(point: IPoint): void {
    this.map.setCenter({
      ...point,
    });
    this.zoom = this.ZOOM_MY_POSITION;
  }
  private _chargeFilters(): void {
    this._dataService.chageFilters().subscribe((filters) => {
      this.filters = filters;
      this._chargeStations();
    });
  }
  public selectFilter(filter: IFilterStation): void {
    filter.selected = !filter.selected;
    this._filterStations();
  }
  public _filterStations(): void {
    const filtersIDs = this.filters
      .filter((filter) => filter.selected)
      .map((filter) => filter.id);

    const countFilters = filtersIDs.length;
    if (countFilters === 0) {
      this.stations = [...this.stationsBase];
    } else {
      this.stations = this.stationsBase.filter((station) => {
        const { attributes } = station;
        const atttributesFound = filtersIDs.filter((idFilter) => {
          return !!attributes.find((attribute) => attribute === idFilter);
        }).length;

        return atttributesFound === countFilters;
      });
    }
    this.pointsBetween.length > 0 && this._filterForRoute();
  }
  private _filterForRoute(): void {
    const points = [];
    let pointLasted = null;
    this.pointsBetween.forEach((point, key) => {
      point.id = key;
      if (key > 0) {
        points.push({
          p1: pointLasted,
          p2: point,
        });
        point.distance = this._mathService.getDistanceBetweenPoints(pointLasted, point);
      }
      pointLasted = point;
    });
    this.stations = this.stations.filter((station) => {
      const { latitude, longitude } = station;
      const pointStation = new google.maps.LatLng(latitude, longitude);
      return points.some((obj) => {
        const { p1, p2 } = obj;
        const isNear = this._mathService.stationIsClose(p1, p2, pointStation);
        return isNear;
      });
    });
  }
  private _calculeDsitanceBetweenPoints(p1: any, p2: any): number {
    return Math.ceil(
      google.maps.geometry.spherical.computeDistanceBetween(p1, p2) / 1000
    );
  }
  private _chargePositionClient() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          console.log('getCurrentPosition', position);
          const { latitude, longitude } = position.coords;
          this.currentClient = {
            lat: latitude,
            lng: longitude,
          };
        },
        (error) => {
          console.log('error al cargar el mapa');
        },
        {
          enableHighAccuracy: true,
        }
      );
    }
  }
  private _positionInitial(): void {
    this.origin = {
      lat: this.LATITUD_INITIAL,
      lng: this.LONGITUD_INITIAL,
    };
    this.zoom = this.ZOOM_MAP_PERU;
  }
  clickedMarker(infowindow, pos) {
    console.log('thiss', this.previous);

    if (this.previous) {
      this.previous.close();
    }
    if (pos === this.posStation) {
      setTimeout(() => {
        this.previous.close();
      }, 10);
    }
    this.posStation = pos;
    this.previous = infowindow;
  }
  public mapClick(event: any): void {
    console.log('event', event);
    if (this.previous) {
      this.previous.close();
      this.previous = null;
    }
    this.posStation = null;
  }
  public changeSearchEnd(): void {
    if (this.searchEndModel === '') {
      this._removeSearchEnd();
    }
  }
  public changeSearchStart(): void {
    if (this.searchStartModel === '') {
      this._removeSearchStart();
    }
  }
  getAddress(latitude, longitude) {
    this.geoCoder.geocode(
      { location: { lat: latitude, lng: longitude } },
      (results, status) => {
        if (status === 'OK') {
          if (results[0]) {
            this.zoom = 12;
            this.address = results[0].formatted_address;
          } else {
            window.alert('No results found');
          }
        } else {
          //window.alert('Geocoder failed due to: ' + status);
        }
      }
    );
  }
}
